import { h as __h } from "preact";
import { Component, h } from "preact";
import { groupResponse } from "~/backend/validate.js";
import { query, paginatedResponse } from "~/lib/api.js";
import { identity } from "~/lib/identity.js";
import { SearchParams } from "~/lib/search.js";
import html from "~/util/html.js";
import { navigate } from "~/util/router.js";
/** @import { RouteParams } from "~/util/router.js"; */

import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import { Crumb } from "~/admin/component/Breadcrumbs.js";
import { ComboboxInput } from "~/admin/component/Combobox.js";
import Pagination from "~/admin/component/Pagination.js";
import Table from "~/admin/component/Table.js";
import GroupsDetail from "./GroupsDetail.js";
/** @import { orgResponse, sessionEnterpriseResponse } from "~/backend/validate.js"; */
import adminStyle from "~/admin/lib/style.js";
import { addGroup } from "~/admin/res/group/actions/addGroup.js";
import GroupTable from "~/admin/res/group/GroupTable.js";
import util from "~/style/util.js";

/**
 * @extends {Component<Props>}
 *
 * @typedef {{
 * 	org: orgResponse;
 * 	enterprise: sessionEnterpriseResponse;
 * } & RouteParams<{ groupId: string | undefined }>} Props
 */
export default class GroupsRoute extends Component {
  render() {
    const groupId = this.props.params.value.groupId;
    return [__h(Crumb, {}, groupId ? __h("a", {
      href: "/org/" + this.props.org.id + "/groups"
    }, "Groups") : "Groups"), groupId ? __h(GroupsDetail, {
      org: this.props.org,
      enterprise: this.props.enterprise,
      groupId: groupId
    }) : __h(Groups, {
      org: this.props.org
    })];
  }
}

/**
 * @extends {Component<GroupsProps>}
 *
 * @typedef {object} GroupsProps
 * @property {orgResponse} org
 */
class Groups extends Component {
  paginate = new Pagination.State();
  sort = new Table.Sort({
    keys: ["name"],
    by: "name"
  });
  groups = query(() => ({
    key: [`/v2/orgs/${this.props.org.id}/groups`, {
      ...this.paginate.query(),
      ...this.sort.query(),
      q: SearchParams.q.value
    }],
    keepPreviousData: true
  }), {
    schema: paginatedResponse(groupResponse)
  });
  render() {
    return __h("div", {
      "class": adminStyle.main
    }, __h(ComboboxInput, {
      query: SearchParams.q,
      debounce: 200
    }), __h("div", {
      "class": adminStyle.body
    }, __h(GroupsActions, {
      orgId: this.props.org.id
    }), __h("div", {
      "class": util.card + " " + adminStyle.tableCard
    }, h(GroupTable, {
      orgId: this.props.org.id,
      paginate: this.paginate,
      sort: this.sort,
      query: this.groups
    }))));
  }
}

/**
 * @extends {Component<GroupsActionsProps>}
 *
 * @typedef {object} GroupsActionsProps
 * @property {string} orgId
 */
class GroupsActions extends Component {
  render() {
    if (!identity.permission(this.props.orgId, "groups", "edit")) return null;
    return __h("menu", {
      "class": adminStyle.menu
    }, __h(Button, {
      size: "small",
      onClick: async () => {
        const res = await addGroup({
          orgId: this.props.orgId
        });
        if (res) navigate(`/org/${this.props.orgId}/groups/${res.id}`);
      }
    }, __h(Icon, {
      name: "plus",
      size: 12
    }), __h("span", {}, "New group")));
  }
}